exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-facial-record-wrapper[data-v-fc6b0708]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-fc6b0708&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/photo/UploadPhotoFacialRecord.vue
// module id = 647
// module chunks = 0